import { render } from "./DrYouTwo.vue?vue&type=template&id=74b1e24e&scoped=true"
import script from "./DrYouTwo.vue?vue&type=script&lang=js"
export * from "./DrYouTwo.vue?vue&type=script&lang=js"

import "./DrYouTwo.vue?vue&type=style&index=0&id=74b1e24e&scoped=true&lang=sass"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b1e24e"]])

export default __exports__